import { useEffect } from "react"
import styles from "./FlashMessage.module.css"

import XIcon from "../../icons/XIcon"

const FlashMessage = ({ message, type = "info", mode = "auto", onClose }) => {
  useEffect(() => {
    if (mode === "auto") {
      const timer = setTimeout(() => {
        onClose()
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [mode, onClose])

  return (
    <div className={`${styles.flash_message} ${styles[type]}`}>
      <div>{message}</div>
      <button className={styles.close_btn} onClick={onClose}>
        <XIcon />
      </button>
    </div>
  )
}

export default FlashMessage
